import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Tag } from '@/components'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { ReservationsListRow } from '@/types/Reservation'
import { formatDate, parseDate } from '@/util'

import { getReservationFXTag, getReservationLexitTag } from './Reservations.data'

interface MobileReservationCardProps {
  header: string
  reservation: ReservationsListRow
}

export function MobileReservationCard({ header, reservation }: MobileReservationCardProps) {
  const navigate = useNavigate()

  function routeToReservation() {
    navigate(`/reservations/${reservation.id}`, { relative: 'path' })
  }

  function routeToHome() {
    navigate(`/homes/${reservation.home.id}`, { relative: 'path' })
  }

  const fxStatus = getReservationFXTag(reservation)
  const lexitStatus = getReservationLexitTag(reservation)

  return (
    <div className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md">
      <div className="mb-1 flex items-center justify-between">
        <p
          className="mb-1 text-p-sm underline"
          onClick={routeToReservation}
          role="presentation"
          style={{ fontWeight: 'bold' }}
        >
          {header}
        </p>
        <div className="inline-flex">
          <Tag className="p-2 py-1 text-p-xs capitalize" variant="info">
            {reservation.status}
          </Tag>
          {fxStatus && (
            <Tag className="ml-1 p-2 py-1 text-p-xs" variant={fxStatus.tag}>
              {fxStatus.label}
            </Tag>
          )}
          {lexitStatus && (
            <Tag className="ml-1 p-2 py-1 text-p-xs" variant={lexitStatus.tag}>
              {lexitStatus.label}
            </Tag>
          )}
        </div>
      </div>
      <div className="mb-1 flex justify-between">
        <p className="flex-none py-2 text-sm text-grey-500">Home Quality Status</p>
        <Tag
          className="p-2 py-1 text-p-xs"
          variant={reservation.homeQualityStatus === HomeQualityCheckStatus.READY ? 'success' : 'error'}
        >
          {reservation.homeQualityStatus}
        </Tag>
      </div>
      <p className="mb-1 text-p-sm underline" onClick={routeToHome} role="presentation">
        {reservation.home.searchDocument}
      </p>
      <div className="flex justify-between">
        <p className="font-light text-p-xs text-grey-500">
          {formatDate(parseDate(reservation.moveInDate), 'MM/dd/yyyy')}
          {` - `}
          {reservation.moveOutDate ? formatDate(parseDate(reservation.moveOutDate), 'MM/dd/yyyy') : 'Indefinite'}
        </p>
      </div>
    </div>
  )
}
